module.exports = __webpack_public_path__ + "static/media/logos_squares_Sup_BTRI.e9116a52.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Sup_BTRI.png
// module id = 47
// module chunks = 0